import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";
import {inject} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {tap} from "rxjs";
import {map} from "rxjs/operators";
import {isDefined} from "../../../../core/util/isDefined";


export const productHandlingStore = signalStore(
    {providedIn: "root"},

    withState({
        current: undefined,
        model3dList: [],
        productTypes: []
    }),

    withMethods((
        store,
        http = inject(HttpClient)
    ) => ({

        clearCurrent(){
          patchState(store, {current: undefined})
        },

        async fetchForEdit( id: number ): Promise<boolean> {
            return await new Promise((resolve) =>
                http.get(`/api/product/${id}`)
                    .pipe(
                        tap((product: any) => patchState(store, {current: product})),
                        map(isDefined)
                    ).subscribe(resolve)
            );
        },

        async fetchForClone( id: number ): Promise<boolean> {
            return await new Promise((resolve) =>
                http.get(`/api/product/${id}`)
                    .pipe(
                        map((product: any)=>({
                            ...product,
                            id: undefined,
                            name: product.name + '-copy',
                            productCode: product.productCode + '-copy',
                        })),
                        tap((product: any) => patchState(store, {current: product})),
                        map(isDefined)
                    ).subscribe(resolve)
            );
        },

        createNewProduct( product: any ){
            return http.post('/api/product', product )
        },

        updateProduct( product: any ){
            return http.put('/api/product', product )
        },

    }))

);